import { Grid, useColorMode, VStack } from '@chakra-ui/react'
import { Body, Themes, useTheme } from '@missionlabs/react'
import { FullLogo as CircleLoopLogo } from '@missionlabs/react/circleloop'
import { FullLogo as PhoneLinePlusLogo } from '@missionlabs/react/phonelineplus'
import { FC, PropsWithChildren } from 'react'

export interface AuthLayoutProps {
    label: string
    contentWidth?: string
    image?: string
}

export const AuthLayout: FC<PropsWithChildren<AuthLayoutProps>> = ({
    label,
    children,
    contentWidth,
    image
}) => {
    const { colorMode } = useColorMode()

    const theme = useTheme().variant

    const FullLogo = theme === Themes.PHONELINEPLUS ? PhoneLinePlusLogo : CircleLoopLogo

    const background = `var(--chakra-colors-${colorMode}-tones-ghostWhite)`
    const desktopBackground = image
        ? `right 50px bottom 70px / 350px no-repeat url(${image}), ` + background
        : background

    return (
        <Grid
            as="main"
            minH="100dvh"
            w="100dvw"
            bg={{ base: background, md: desktopBackground }}
            overflowY="auto"
            templateColumns={{ base: '1fr', md: 'minmax(250px, 25%) 1fr', xl: '372px 1fr' }}
            templateRows={{ base: 'auto 1fr', md: '1fr' }}
        >
            <VStack
                spacing="24px"
                padding={{ base: '24px', md: '32px', xl: '64px' }}
                align={{ base: 'start', md: 'end' }}
                justify={{ base: 'center', md: 'initial' }}
                minH={{ base: '120px', md: 'auto' }}
                bg={`${colorMode}.alerts.red`}
            >
                <FullLogo h="auto" w={{ base: '180px', xl: '212px' }} color="white" />
                <Body
                    display={{ base: 'none', md: 'block' }}
                    sx={{ color: `${colorMode}.alerts.redLight` }}
                >
                    v{__VERSION__}
                </Body>
            </VStack>
            <VStack
                spacing="16px"
                w="full"
                maxW={contentWidth || '312px'}
                margin={{ base: '24px', md: '32px', xl: '64px' }}
                align="center"
            >
                <Body size="lg" alignSelf="start">
                    {label}
                </Body>
                <VStack spacing={6} w="100%">
                    {children}
                </VStack>
            </VStack>
        </Grid>
    )
}
